import { useImageAnnotatorContext } from "@msuite/image-annotator";
import type { DimensionAnnotation, PolygonAnnotation } from "@msuite/utils/types";

export function AnnotationToolbarSubMenuText() {
	/** Context */
	const context = useImageAnnotatorContext();
	const selectedAnnotation = context.controller.getSelectedAnnotation() as
		| PolygonAnnotation
		| DimensionAnnotation;

	/** Guard */
	if (!selectedAnnotation) return null;

	/** Render */
	return (
		<input
			key={selectedAnnotation.id}
			autoFocus
			className="px-3 py-2 rounded-md border-[0.5px] border-primary-700 bg-primary-900 text-white text-xs w-full"
			placeholder="Label"
			defaultValue={selectedAnnotation.text}
			onChange={(e) => context.controller.handleOnUpdateSelection({ text: e.target.value })}
			type={selectedAnnotation.type === "dimension" ? "number" : "text"}
		/>
	);
}
